import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const GeneratorPixelIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3H13V4H14V5H15V6H14V7H11V8H10V9H3V18H21V9H11V8H14V7H15V6H16V5H15V4H14V3ZM21 20V19H3V20H21ZM5 11H4V12H5V11ZM9 11H8V12H7V11H6V12H7V13H6H4V14H6H7V15H6H4V16H6H7V15H8V16H18V15H19V16H20V15H19V14H20V13H19V14H18V13H17H16V12H17V11H16V12H15V11H14V12H13V11H12V12H11V11H10V12H9V11ZM9 13V12H8V13H7V14H8V15H9V14H10V15H11V14H12V15H13V14H14V15H15V14H16V15H18V14H17H16V13H15V12H14V13H13V12H12V13H11V12H10V13H9ZM10 13H11V14H10V13ZM12 13V14H13V13H12ZM14 13H15V14H14V13ZM9 13V14H8V13H9ZM20 11H19V12H20V11Z"
        fill={fillColor || '#67666D'}
      />
    </svg>
  );
};

export { GeneratorPixelIcon };
